import React, { useEffect, useState, useContext } from "react";
import Textinput from "../elements/TextInput/TextInput";
import Selectbox from "../elements/SelectBox/SelectBox";
import Button from "../elements/Button/Button";
import { useCommonContext } from "../../context/CommonContext";
import { useNavigate } from "react-router-dom";
import Textarea from "../elements/TextArea/TextArea";
import CryptoJS from "crypto-js";
import { AuthContext } from "../../context/AuthContext";

const Jobscreen = () => {
  const navigate = useNavigate();
  const {
    jobCreationData,
    setJobCreationData,
    validationErrors,
    sanitizeInput,
  } = useCommonContext();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    if (Object.keys(validationErrors).length > 0) {
      const errorElement = document.querySelector(".validation-check-failed");
      console.log("Validation error found but not found the div");
      if (errorElement) {
        console.log("Validation error found, scrolling...");
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
        errorElement.focus();
      }
    }
  }, [validationErrors]);

  const gobacktochatbot = () => {
    navigate("/JobCreation");
  };

  const [skills, setSkills] = useState([
    "Education",
    "Background Check",
    "Expertise With Skill",
    "Driver's License",
    "Hybrid Work",
    "Drug Test",
    "Industry Experience",
  ]);
  const [customSkill, setCustomSkill] = useState("");
  const [showCustomInput, setShowCustomInput] = useState(false);
  const { token } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState({ message: "", type: "" });
  const showNotification = (message, type) => {
    //For Notification
    setNotification({ message, type });
    setTimeout(() => {
      setNotification({ message: "", type: "" });
    }, 3000); // Auto-hide after 3 seconds
  };
  const [WorkplaceTypeVal, SetWorkplaceTypeVal] = useState();
  const [jobTypeVal, SetJobTypeVal] = useState();
  // const [company, SetCompanyVal] = useState();

  useEffect(() => {
    fetchSuggestions();
  }, []);

  const fetchSuggestions = async () => {
    const encryptedMetadata = localStorage.getItem("metadata");
    let company_id = "";
    if (encryptedMetadata) {
      const decryptedMetadata = JSON.parse(
        CryptoJS.AES.decrypt(
          encryptedMetadata,
          process.env.REACT_APP_SECRETKEY
        ).toString(CryptoJS.enc.Utf8)
      );
      company_id = decryptedMetadata?.cid || "";
    }

    const serverURL = process.env.REACT_APP_SERVER_URL;
    const jsonData = { cid: company_id, type: "Skills" };
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(jsonData),
      process.env.REACT_APP_SECRETKEY
    ).toString();

    setIsLoading(true);
    try {
      const response = await fetch(`${serverURL}/masters/selectData`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token,
        },
        body: JSON.stringify({ data: encryptedData }),
      });

      const data = await response.json();
      if (data.status !== "success") {
        showNotification(data.message || "Failed to fetch data.", "error");
        return;
      }

      let decryptedData = data.data;
      if (typeof data.data === "string") {
        decryptedData = JSON.parse(
          CryptoJS.AES.decrypt(
            data.data,
            process.env.REACT_APP_SECRETKEY
          ).toString(CryptoJS.enc.Utf8)
        );
      }
      const fetchedSuggestions = decryptedData.map((item) => item.skill);
      // setSkills(fetchedSuggestions);
      if (fetchedSuggestions.length > 0) {
        setSkills(fetchedSuggestions);
      }
    } catch (error) {
      showNotification("Something went wrong while loading data.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const toggleSkill = (skill) => {
    setJobCreationData((prev) => ({
      ...prev,
      selectedSkills: prev.selectedSkills?.includes(skill)
        ? prev.selectedSkills.filter((s) => s !== skill)
        : [...prev.selectedSkills, skill],
    }));
  };

  const addCustomSkill = () => {
    if (customSkill && !skills.includes(customSkill)) {
      setSkills((prev) => [...prev, customSkill]);
      setJobCreationData((prev) => ({
        ...prev,
        selectedSkills: [...prev.selectedSkills, customSkill],
      }));
      setCustomSkill("");
      setShowCustomInput(false);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const sanitizedValue = sanitizeInput(value);
    setJobCreationData((prev) => ({
      ...prev,
      [name]: sanitizedValue,
    }));
  };

  const workplaceTypeData = [
    { id: "0", label: "" },
    { id: "1", label: "On-Site" },
    { id: "2", label: "Hybrid" },
    { id: "3", label: "Remote" },
  ];

  const jobTypeData = [
    { id: "0", label: "" },
    { id: "1", label: "Full - time" },
    { id: "2", label: "Part - time" },
    { id: "3", label: "Contract" },
    { id: "4", label: "Temporary" },
    { id: "5", label: "Other" },
    { id: "6", label: "Volunteer" },
    { id: "7", label: "Internship" },
  ];

  const ValueFind = (value, type) => {
    if (type != "" && type != undefined && type != "_blank") {
      const data = value.find((key) => key.label === type);
      return data.id;
    } else {
      return 0;
    }
  };

  const FindCompany = () => {
    const encryptedMetadata = localStorage.getItem("metadata");
    const decryptedMetadata = JSON.parse(
      CryptoJS.AES.decrypt(
        encryptedMetadata,
        process.env.REACT_APP_SECRETKEY
      ).toString(CryptoJS.enc.Utf8)
    );
    console.log("The decrypted metadata :: ", decryptedMetadata);
    if (
      decryptedMetadata &&
      decryptedMetadata.company_name &&
      decryptedMetadata.company_name != ""
    ) {
      var companyName = decryptedMetadata.company_name;
      jobCreationData.company = companyName;
      return companyName;
    } else {
      return "";
    }
  };

  const setValueChange = (e) => {
    console.log(jobCreationData);
    const { id, value } = e.target;
    switch (id) {
      case "SetWorkplaceTypeVal":
        SetWorkplaceTypeVal(value);
        setJobCreationData((prev) => ({
          ...prev,
          ["workplaceType"]: workplaceTypeData.find((item) => item.id === value)
            .label,
        }));
        break;
      case "SetJobTypeVal":
        SetJobTypeVal(value);
        setJobCreationData((prev) => ({
          ...prev,
          ["jobType"]: jobTypeData.find((item) => item.id === value).label,
        }));
        break;
      default:
        console.warn(`No Value Updated :${id}`);
    }
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="mb-6">
        <p className="text-lg sm:text-xl font-medium mb-2">
          Review Job Description
        </p>
        <p className="text-gray-600 text-sm sm:text-base">
          Add members below which will be visible to the Job seekers under 'Meet
          your teams' sections
        </p>
      </div>

      {/* First Row - Company, Job Title, Workplace Type */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <div className="w-full">
          <Textinput
            disable={true}
            label="Company"
            value={FindCompany() || jobCreationData.company}
            name="company"
            labelclass="font-medium"
            className={`w-full outline-none border-[#BFE0E2] ${
              validationErrors.company
                ? "!border-red-500 validation-check-failed"
                : ""
            }`}
          />
        </div>
        <div className="w-full">
          <Textinput
            label="Job Title"
            value={jobCreationData.jobTitle}
            name="jobTitle"
            onChange={handleInputChange}
            labelclass="font-medium"
            className={`w-full outline-none border-[#BFE0E2] ${
              validationErrors.jobTitle
                ? "!border-red-500 validation-check-failed"
                : ""
            }`}
          />
        </div>
        <div className="w-full">
          <Selectbox
            label="Workplace Type"
            labelClass="mb-2 font-semibold font-medium"
            list={workplaceTypeData}
            id="SetWorkplaceTypeVal"
            value={ValueFind(workplaceTypeData, jobCreationData.workplaceType)}
            onChange={(e) => setValueChange(e)}
            customClass={`border-2 rounded-lg focus:ring-0 p-[11px] mt-0 w-full outline-none border-[#BFE0E2] ${
              validationErrors.workplaceType
                ? "!border-red-500 validation-check-failed"
                : ""
            }`}
          />
        </div>
      </div>

      {/* Second Row - Job Location, Job Type */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        <div className="w-full">
          <Textinput
            label="Job Location"
            value={jobCreationData.jobLocation}
            name="jobLocation"
            onChange={handleInputChange}
            labelclass="font-medium"
            className={`w-full outline-none border-[#BFE0E2] ${
              validationErrors.jobLocation
                ? "!border-red-500 validation-check-failed"
                : ""
            }`}
          />
        </div>
        <div className="w-full">
          <Selectbox
            label="Job Type"
            labelClass="mb-2 font-semibold font-medium"
            list={jobTypeData}
            id="SetJobTypeVal"
            value={ValueFind(jobTypeData, jobCreationData.jobType)}
            onChange={(e) => setValueChange(e)}
            customClass={`border-2 rounded-lg focus:ring-0 p-[11px] mt-0 w-full outline-none border-[#BFE0E2] ${
              validationErrors.jobType
                ? "!border-red-500 validation-check-failed"
                : ""
            }`}
          />
        </div>
      </div>

      {/* Description Section */}
      <div className="w-full mb-8">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4">
          <p className="mb-2 sm:mb-0 font-semibold">Description*</p>
          <Button
            onClick={() => gobacktochatbot()}
            className="bg-white text-[#059669] text-sm !border-1 border-[#059669] px-4 py-2 rounded-lg w-full sm:w-auto"
          >
            Rewrite with AI +
          </Button>
        </div>
        <Textarea
          labelclass="hidden"
          className={`w-full outline-none !border-[#BFE0E2] resize-none ${
            validationErrors.description
              ? "!border-red-500 validation-check-failed"
              : ""
          }`}
          value={jobCreationData.description}
          name="description"
          style={{ height: "300px", fontSize: "15px" }}
          onChange={handleInputChange}
        />
      </div>

      {/* Skills Section */}
      <div className="mb-8">
        <p className="text-lg font-medium mb-4">Skills</p>
        <div
          className={`w-full sm:w-3/4 lg:w-2/3 outline-none ${
            validationErrors.selectedSkills ? "border-2 border-red-500" : ""
          }`}
        >
          <div className="flex flex-wrap gap-3">
            {skills.length === 0
              ? skills.map((skill) => (
                  <button
                    key={skill}
                    className={`px-3 py-2 text-sm rounded-full transition-colors ${
                      jobCreationData.selectedSkills?.includes(skill)
                        ? "bg-[#F2F9F9] text-[#059669]"
                        : "!bg-[#F2F2F2] text-gray-700"
                    }`}
                    onClick={() => toggleSkill(skill)}
                  >
                    {skill} +
                  </button>
                ))
              : skills.map((skill) => (
                  <button
                    key={skill}
                    className={`px-3 py-2 text-sm rounded-full transition-colors ${
                      jobCreationData.selectedSkills?.includes(skill)
                        ? "bg-[#F2F9F9] text-[#059669]"
                        : "!bg-[#F2F9F9] text-gray-700"
                    }`}
                    onClick={() => toggleSkill(skill)}
                  >
                    {skill} +
                  </button>
                ))}
            <button
              className="px-3 py-2 text-sm rounded-full bg-[#F2F9F9] text-[#059669] transition-colors hover:bg-[#E6F3F3]"
              onClick={() => setShowCustomInput(true)}
            >
              Custom +
            </button>
          </div>
        </div>

        {showCustomInput && (
          <div className="flex flex-col sm:flex-row gap-3 mt-4">
            <input
              type="text"
              className="border p-3 rounded text-sm flex-1"
              placeholder="Enter custom skill"
              value={customSkill}
              onChange={(e) => setCustomSkill(sanitizeInput(e.target.value))}
            />
            <button
              className="px-4 py-3 text-sm rounded-full bg-teal-200 text-teal-800 font-medium transition-colors hover:bg-teal-300"
              onClick={addCustomSkill}
            >
              Add Skill
            </button>
          </div>
        )}

        {/* Selected Skills */}
        <div className="mt-6">
          <p className="text-md font-medium mb-3">Selected Skills</p>
          <div className="flex flex-wrap gap-2 w-full sm:w-3/4 lg:w-2/3">
            {jobCreationData.selectedSkills?.map((skill) => (
              <div
                key={skill}
                className="flex items-center bg-[#F2F9F9] px-3 py-2 rounded-full"
              >
                <span className="text-sm mr-2">{skill}</span>
                <button
                  style={{ cursor: "pointer" }}
                  className="text-sm text-gray-500 hover:text-red-500 transition-colors"
                  onClick={() => toggleSkill(skill)}
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Jobscreen;
